import React from 'react';
import { useModels } from '../../contexts/ModelContext';

const Toolbar = ({
  chatTitle,
  model,
  selectedModel,
  hasArtifact = false,
  isArtifactExpanded = false,
  chatWidth = 100,
  isDualMode = false,
}) => {
  const { models, getModelByModelString, defaultModel } = useModels();

  const getModelDetails = (modelString) => (
    getModelByModelString(modelString) ||
    models.find((item) => item.name?.toLowerCase() === (modelString || '').toLowerCase()) ||
    defaultModel
  );

  const modelDetails = getModelDetails(model || selectedModel);
  const displayModelName = modelDetails ? modelDetails.name : 'Deprecated Model';
  const modelColor = modelDetails ? modelDetails.color : '#808080';
  const isNewChat = !chatTitle || chatTitle === 'New Chat';
  const isSettings = !chatTitle || chatTitle === 'Settings';

  const getToolbarStyle = () => {
    if (isArtifactExpanded) {
      return { right: 0 };
    }
    if (hasArtifact) {
      return { right: `${100 - chatWidth}%` };
    }
    return { right: 0 };
  };

  return (
    <div
      className="flex items-center justify-center bg-opacity-00 dark:bg-opacity-0 p-4 absolute top-0 left-0 z-10 h-16 transition-all duration-300"
      style={getToolbarStyle()}
      data-toolbar
    >
      <div className="flex min-w-0 items-center justify-center">
        <div className="flex items-center">
          {!isNewChat && !isSettings && (
            <>
              <h1 className="text-xl font-semibold theme-text-primary mr-4">
                {chatTitle}
              </h1>
              {!isDualMode && (
                <span
                  className="px-3 py-1 text-sm rounded-full text-white"
                  style={{
                    backgroundColor: modelColor,
                    opacity: 1.0,
                    transition: 'background-color 0.3s'
                  }}
                >
                  {displayModelName}
                </span>
              )}
            </>
          )}

          {isSettings && (
            <h1 className="text-xl font-semibold theme-text-primary mr-4">
              {chatTitle}
            </h1>
          )}
        </div>
      </div>
    </div>
  );
};

export default Toolbar;
